import Icon from '@atoms/Icon/Icon';
import Image from '@atoms/Image/Image';
import Text from '@atoms/Text/Text';
import { IArticleCard } from '@models/IArticleCard';
import classNames from 'classnames';

const bgClasses: Record<'white' | 'grey', string> = {
  white: 'tw-bg-white',
  grey: 'tw-bg-grey-10',
};

const ArticleCard = ({
  background = 'grey',
  displayAsTitle,
  image,
  portraitImages,
  tags,
  target,
  text,
  title,
  titleVariant = 'heading-24-light',
  trumpetText,
  truncateTitle = false,
  truncateText = false,
  url,
}: IArticleCard) => (
  <article className="tw-h-full">
    <a
      className="tw-group tw-flex tw-h-full tw-flex-col hover:tw-cursor-pointer focus:tw-text-grey-100 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-white focus:tw-ring-offset-2 focus:tw-ring-offset-grey-100"
      href={url}
      target={target}
    >
      <Image
        imageClasses="tw-w-full tw-object-cover"
        aspectRatio={portraitImages ? 0.8 : 1.5}
        image={image}
        sizes="500px"
      />
      <div
        className={classNames(
          'tw-flex tw-grow tw-flex-col tw-items-start tw-px-xs tw-py-sm tw-transition-colors tw-@container/article-card group-hover:tw-bg-grey-20 md:tw-px-sm',
          bgClasses[background]
        )}
      >
        {trumpetText && (
          <Text
            variant="body-small"
            className="tw-mb-xs tw-uppercase tw-text-grey-70 @md/article-card:tw-mb-6"
          >
            {trumpetText}
          </Text>
        )}
        <div className="tw-mb-xs tw-flex tw-w-full @md/article-card:tw-mb-6">
          <Text
            as={displayAsTitle ? 'h3' : 'p'}
            variant={titleVariant}
            className={classNames(
              'tw-mr-1 tw-font-light tw-text-black',
              truncateTitle &&
                'tw-overflow-hidden  tw-text-ellipsis tw-whitespace-nowrap '
            )}
          >
            {title}
          </Text>
          <Icon
            name="arrow-right"
            className={classNames(
              'tw-ml-auto tw-max-w-5 tw-shrink-0 tw-text-grey-40 tw-transition-colors group-hover:tw-text-grey-100 group-focus:tw-text-grey-100 @md/article-card:tw-max-w-6',
              truncateTitle
                ? 'tw-my-auto'
                : 'tw-mb-auto tw-mt-2 @md/article-card:tw-mt-3'
            )}
            size={24}
          />
        </div>
        <Text
          variant="body"
          className={classNames(
            'tw-text-grey-80',
            truncateText
              ? 'tw-line-clamp-3 tw-overflow-hidden tw-text-ellipsis'
              : ''
          )}
        >
          {text}
        </Text>
        {tags && tags.length > 0 && (
          <ul className="tw-mt-auto tw-flex tw-flex-row tw-flex-wrap tw-gap-2 tw-pt-sm @md/article-card:tw-pt-6">
            {tags.map((tag: string) => (
              <li
                key={tag}
                className="tw-flex tw-rounded tw-border tw-border-grey-30 tw-px-2 tw-py-[3px] tw-text-xs tw-text-grey-70"
              >
                {tag}
              </li>
            ))}
          </ul>
        )}
      </div>
    </a>
  </article>
);

export default ArticleCard;
